export const useStyles = (theme) => ({
  leftFoot: {
    display: "inline-flex",
  },
  button: {
    margin: theme.spacing(1),
  },


  rightFoot: {},

});
